/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_IndieInputs */

const id_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const ms_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const da_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const de_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const en_us2_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const es_es2_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const es_mx2_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const fil_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const fr_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const it_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const hu_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const nl_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const no_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const pl_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const pt_br2_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const pt_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const ro_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const fi_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const sv_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const vi_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const tr_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bağımsız`)
};

const cs_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indie`)
};

const bg_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инди`)
};

const ru_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инди`)
};

const uk_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Інді`)
};

const ar_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مستقل`)
};

const hi_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इंडी`)
};

const th_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อินดี้`)
};

const ja_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インディー`)
};

const zh_cn2_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立`)
};

const zh_hant1_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`獨立`)
};

const ko_nav_indie = /** @type {(inputs: Nav_IndieInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`인디`)
};

/**
* | output |
* | --- |
* | "Indie" |
*
* @param {Nav_IndieInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const nav_indie = /** @type {((inputs?: Nav_IndieInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_IndieInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_nav_indie(inputs)
	if (locale === "ms") return ms_nav_indie(inputs)
	if (locale === "da") return da_nav_indie(inputs)
	if (locale === "de") return de_nav_indie(inputs)
	if (locale === "en-US") return en_us2_nav_indie(inputs)
	if (locale === "es-ES") return es_es2_nav_indie(inputs)
	if (locale === "es-MX") return es_mx2_nav_indie(inputs)
	if (locale === "fil") return fil_nav_indie(inputs)
	if (locale === "fr") return fr_nav_indie(inputs)
	if (locale === "it") return it_nav_indie(inputs)
	if (locale === "hu") return hu_nav_indie(inputs)
	if (locale === "nl") return nl_nav_indie(inputs)
	if (locale === "no") return no_nav_indie(inputs)
	if (locale === "pl") return pl_nav_indie(inputs)
	if (locale === "pt-BR") return pt_br2_nav_indie(inputs)
	if (locale === "pt") return pt_nav_indie(inputs)
	if (locale === "ro") return ro_nav_indie(inputs)
	if (locale === "fi") return fi_nav_indie(inputs)
	if (locale === "sv") return sv_nav_indie(inputs)
	if (locale === "vi") return vi_nav_indie(inputs)
	if (locale === "tr") return tr_nav_indie(inputs)
	if (locale === "cs") return cs_nav_indie(inputs)
	if (locale === "bg") return bg_nav_indie(inputs)
	if (locale === "ru") return ru_nav_indie(inputs)
	if (locale === "uk") return uk_nav_indie(inputs)
	if (locale === "ar") return ar_nav_indie(inputs)
	if (locale === "hi") return hi_nav_indie(inputs)
	if (locale === "th") return th_nav_indie(inputs)
	if (locale === "ja") return ja_nav_indie(inputs)
	if (locale === "zh-CN") return zh_cn2_nav_indie(inputs)
	if (locale === "zh-Hant") return zh_hant1_nav_indie(inputs)
	return ko_nav_indie(inputs)
});
export { nav_indie as "nav.indie" }